import { ClockIcon, RotateCcwIcon } from "lucide-react";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Separator } from "@/components/ui/separator";

import type { DecayProfileEditorProps } from "../../types/decay";
import AssignmentGrid from "./AssignmentGrid";
import ProfileTable from "./ProfileTable";

const DecayProfileEditor = (props: DecayProfileEditorProps) => {
  const {
    profiles,
    assignments,
    onUpdateProfile,
    onAddProfile,
    onDeleteProfile,
    onSetAssignment,
    onReset,
  } = props;

  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button variant="outline" size="sm">
          <ClockIcon className="mr-1.5 h-3.5 w-3.5" />
          Decay profiles
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-5xl max-h-[85vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Decay profiles</DialogTitle>
          <DialogDescription>
            Define how interactions lose influence over time. Assign a default
            profile per interaction type below.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-2">
          <h3 className="text-sm font-semibold">Profiles</h3>
          <ProfileTable
            profiles={profiles}
            onUpdate={onUpdateProfile}
            onDelete={onDeleteProfile}
            onAdd={onAddProfile}
          />
        </div>

        <Separator />

        <div className="space-y-2">
          <h3 className="text-sm font-semibold">Default assignments</h3>
          <AssignmentGrid
            profiles={profiles}
            assignments={assignments}
            onSet={onSetAssignment}
          />
        </div>

        <div className="flex justify-end pt-2">
          <Button variant="outline" size="sm" onClick={onReset}>
            <RotateCcwIcon className="mr-1.5 h-3.5 w-3.5" />
            Reset to defaults
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default DecayProfileEditor;
